import React from 'react';

import "./HeadPane.scss";

import { Menu } from "./Menu/Menu";

export const HeadPane = (props)=>{
    const {} = props;
    
    return (
        <nav className="HeadPane">

        </nav>
    )
}

